// assets/svd-productblock-variant-selector.js
(function () {
  'use strict';

  function initBlock(block) {
    // Init-vakt: skriptet kan ligga inne TVÅ gånger på samma sida (både
    // LP-sektionen och snippeten skriver ut script-taggen) — utan vakten får
    // blocket dubbla klick-lyssnare och varje köp läggs 2× (hittat 2026-08-18
    // vid live-verifiering av engångs-stacken på Magbalans-LP:n).
    if (block.dataset.svdVsInit) return;
    block.dataset.svdVsInit = '1';
    var rows = Array.from(block.querySelectorAll('.svd-vs__row'));
    var atcBtn = block.querySelector('.svd-vs__atc');
    if (!rows.length || !atcBtn) return;

    var defaultBtnText = atcBtn.textContent.trim();
    var availableRows = rows.filter(function (r) { return r.dataset.available !== 'false'; });
    var afterAdd = block.dataset.afterAdd || 'drawer';

    function isSoldOut(row) {
      return row.dataset.available === 'false';
    }

    // --- Välj en rad ---
    function selectRow(row) {
      if (isSoldOut(row)) return;
      rows.forEach(function (r) {
        r.classList.remove('svd-vs__row--selected');
        r.setAttribute('aria-checked', 'false');
        r.setAttribute('tabindex', '-1');
      });
      row.classList.add('svd-vs__row--selected');
      row.setAttribute('aria-checked', 'true');
      row.setAttribute('tabindex', '0');
      row.focus();
    }

    // Om default-raden är slutsåld, välj första tillgängliga
    var preselected = block.querySelector('.svd-vs__row--selected');
    if (!preselected && availableRows.length) {
      availableRows[0].classList.add('svd-vs__row--selected');
      availableRows[0].setAttribute('aria-checked', 'true');
      availableRows[0].setAttribute('tabindex', '0');
    }

    // --- Klick ---
    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        if (isSoldOut(row)) return;
        selectRow(row);
      });
      // Tangentbord: Space och Enter väljer raden
      row.addEventListener('keydown', function (e) {
        var idx = availableRows.indexOf(row);
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          if (!isSoldOut(row)) selectRow(row);
        }
        // Piltangenter navigerar bara bland tillgängliga rader
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          selectRow(availableRows[idx + 1] || availableRows[0]);
        }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          selectRow(availableRows[idx - 1] || availableRows[availableRows.length - 1]);
        }
      });
    });

    // --- ATC ---
    atcBtn.addEventListener('click', async function () {
      var selected = block.querySelector('.svd-vs__row--selected');
      if (!selected) return;

      var variantId = selected.dataset.variantId;
      var gwpEnabled = selected.dataset.gwpEnabled === 'true';
      var gwpVariantId = selected.dataset.gwpVariantId;

      var mainId = parseInt(variantId, 10);
      if (!variantId || isNaN(mainId)) return;

      var items = [{ id: mainId, quantity: 1 }];
      var gwpId = parseInt(gwpVariantId, 10);
      if (gwpEnabled && gwpId > 0) {
        items.push({
          id: gwpId,
          quantity: 1,
          properties: { _gwp: 'true' }
        });
      }

      // Engångs-stacken (metaobjektet svd_erbjudande_stack, renderad som
      // [data-svd-lpo] i samma sektion av svd-lp-offer-one): kvalificerar vald
      // variant (data-main-ids) läggs stackens gåvor (data-gift-ids) med _gwp —
      // gwp-motorn i svd-functions gör raderna gratis. Saknas stacken händer inget.
      try {
        var lpoBox = (block.closest('.shopify-section') || document).querySelector('[data-svd-lpo]');
        if (lpoBox) {
          var lpoMain = JSON.parse(lpoBox.getAttribute('data-main-ids') || '[]');
          var lpoGifts = JSON.parse(lpoBox.getAttribute('data-gift-ids') || '[]');
          // _gwp_main/_gwp_min (2026-08-25): samma stämpel som bundle-v2 så att
          // varukorgens syncGwp kan städa gåvorna när huvudprodukten tas bort.
          var lpoPid = lpoBox.getAttribute('data-main-pid') || '';
          if (lpoMain.indexOf(mainId) !== -1) {
            lpoGifts.forEach(function (gid) {
              gid = parseInt(gid, 10);
              if (gid <= 0) return;
              var gp = { _gwp: 'true' };
              if (lpoPid) { gp._gwp_main = lpoPid; gp._gwp_min = '1'; }
              items.push({ id: gid, quantity: 1, properties: gp });
            });
          }
        }
      } catch (e) { /* trasig stack-data → köp utan gåvor hellre än inget köp */ }

      // === Upsell-popup (Svd) ============================================
      // Finns popupen på sidan: visa den FÖRST och lägg ev. valda upsell-
      // varianter i SAMMA köp (med _popup_deal-flaggan så deal-priset gäller,
      // precis som popupens eget flöde). Saknas popupen eller hoppar kunden
      // över -> [] och allt körs precis som tidigare. Ett popup-fel får aldrig
      // blockera köpet.
      // Vid "checkout"-läget hoppas popupen över för snabbaste väg till betalning.
      if (afterAdd !== 'checkout' && window.SvdUpsellPopup && typeof window.SvdUpsellPopup.offer === 'function') {
        try {
          var upsellIds = await window.SvdUpsellPopup.offer();
          (upsellIds || []).forEach(function (uid) {
            var pid = parseInt(uid, 10);
            if (pid > 0) items.push({ id: pid, quantity: 1, properties: { _popup_deal: '1' } });
          });
        } catch (e) {
          console.warn('[svd-vs] upsell-popup fel (ignoreras)', e);
        }
      }

      atcBtn.disabled = true;
      atcBtn.textContent = 'Lägger till…';

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });

        var cartData = await res.json();
        if (!res.ok) {
          throw new Error(cartData.description || 'Kunde inte lägga till');
        }

        try { block.dispatchEvent(new CustomEvent('svd:picker:added', { bubbles: true })); } catch (e) { /* svd-kontrakt */ }
        if (afterAdd === 'checkout') {
          window.location.href = '/checkout';
          return;
        }

        if (afterAdd === 'cart') {
          window.location.href = '/cart';
          return;
        }

        // Trigga temats cart drawer (Vision 2024 / app.js)
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart:item-added', {
            product: cartData.items ? cartData.items[0] : cartData
          });
          dispatchCustomEvent('cart:refresh');
          dispatchCustomEvent('cart-drawer:open');
        } else {
          // Fallback om temats app.js inte laddats
          window.location.href = '/cart';
        }

      } catch (err) {
        console.error('[svd-vs] Cart error:', err);
        atcBtn.textContent = 'Fel – försök igen';
        setTimeout(function () {
          atcBtn.disabled = false;
          atcBtn.textContent = defaultBtnText;
        }, 2500);
        return;
      }

      atcBtn.disabled = false;
      atcBtn.textContent = defaultBtnText;
    });
  }

  function init() {
    document.querySelectorAll('.svd-vs').forEach(function (block) {
      initBlock(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* svd-kontrakt (Claude 2026-09-25): montera väljare som injicerats i produktkortets
     "Lägg till"-blad (assets/svd-popup-quickadd.js) — bara rötter i e.detail.root. */
  document.addEventListener('svd:picker:mount', function (e) {
    var host = e && e.detail && e.detail.root;
    if (!host || !host.querySelectorAll) return;
    Array.prototype.forEach.call(host.querySelectorAll('.svd-vs'), initBlock);
  });
})();
